export type Gradient = LinearGradient | RepeatingLinearGradient | RadialGradient | RepeatingRadialGradient;

export enum GradientTypes {
	Linear = "linear-gradient",
	LinearRepeating = "repeating-linear-gradient",
	Radial = "radial-gradient",
	RadialRepeating = "repeating-radial-gradient",
}

interface LinearGradient
{
	type: GradientTypes.Linear;
	orientation: Directional | Angular;
	colorStops: GradientColorStop[];
}

interface RepeatingLinearGradient
{
	type: GradientTypes.LinearRepeating;
	orientation: Directional | Angular;
	colorStops: GradientColorStop[];
}

interface RadialGradient
{
	type: GradientTypes.Radial;
	orientation: Array<Shape | DefaultRadial> | undefined;
	colorStops: GradientColorStop[];
}

interface RepeatingRadialGradient
{
	type: GradientTypes.RadialRepeating;
	orientation: Array<Shape | DefaultRadial> | undefined;
	colorStops: GradientColorStop[];
}

interface Directional
{
	type: GradientOrientations.Directional;
	value: "left" | "top" | "right" | "bottom";
}

interface Angular
{
	type: GradientOrientations.Angular;
	value: number;
}

export enum GradientOrientations {
	Directional = "directional",
	Angular = "angular",
}

interface Shape
{
	type: "shape";
	style: RadialValue | undefined;
	value: "ellipse" | "circle";
	at: {
		x: RadialValue | undefined;
		y: RadialValue | undefined;
	}
}

interface DefaultRadial
{
	at: {
		x: RadialValue | undefined;
		y: RadialValue | undefined;
	}
}

type UnitValue = "px" | "em" | "%";
type RadialValue = ExtentKeyword | UnitValue | PositioningKeyword;
type ExtentKeyword = "closest-side" | "closest-corner" | "farthest-side" | "farthest-corner" | "contain" | "cover";
type PositioningKeyword = "center" | "left" | "top" | "bottom" | "right";

export type GradientColorStop = {
	length: ColorStopLength | undefined;
	type: GradientColorStopTypes;
	value: string | Array<string>; // array of number strings; string could be number or could be literal color name
};

type ColorStopLength = {
	type: UnitValue;
	value: string; // but is actually a number string
}

export enum GradientColorStopTypes {
	Literal = "literal",
	Hex = "hex",
	Rgb = "rgb",
	Rgba = "rgba",
}